import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

enum Tabs {
  ACTIVE = 'active',
  HISTORIC = 'historic',
}

const NotificationsSubTabs: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: 'planningPrognosis.tabs.active' }),
          value: Tabs.ACTIVE,
        },
        {
          label: intl.formatMessage({ id: 'planningPrognosis.tabs.historic' }),
          value: Tabs.HISTORIC,
        },
      ]}
    />
  );
};

export default React.memo(NotificationsSubTabs);
